import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import {
  LIBRARY_REQUEST_ACTIONS,
  describeLibraryRequestActivity,
  sortLibraryRequestActivityNewestFirst,
} from "../../utils/libraryRequestDetailsView";

function ActivityMarker({ action }) {
  if (action === LIBRARY_REQUEST_ACTIONS.rejected) {
    return <XCircleIcon className="size-6 text-red-500" aria-hidden="true" />;
  }
  return <CheckCircleIcon className="size-6 text-green-600" aria-hidden="true" />;
}

export default function LibraryRequestActivityTimeline({ activity, contacts }) {
  const items = sortLibraryRequestActivityNewestFirst(activity);

  return (
    <div className="mt-10 md:mt-6">
      <h2 className="text-sm font-semibold text-gray-900 ml-2">Library Request Activity</h2>
      {items.length ? (
        <ul className="mt-6 space-y-6 h-80 overflow-y-auto px-2">
          {items.map((item, index) => {
            const { actor, message, when, whenLabel } = describeLibraryRequestActivity(
              item,
              contacts
            );
            const showConnector = index < items.length - 1;

            return (
              <li
                key={`${item.action}-${item.action_on ?? index}`}
                className="relative flex gap-x-4"
              >
                {showConnector && (
                  <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                    <div className="w-px bg-gray-200" />
                  </div>
                )}
                <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                  <ActivityMarker action={item.action} />
                </div>
                <div className="flex min-w-0 flex-auto items-start justify-between gap-x-4 py-0.5">
                  <p className="text-xs leading-5 text-gray-500">
                    {actor ? (
                      <>
                        <span className="font-medium text-gray-900">{actor}</span> {message}
                      </>
                    ) : (
                      <span className="text-gray-700">{message}</span>
                    )}
                  </p>
                  {whenLabel ? (
                    <time dateTime={when} className="flex-none text-xs leading-5 text-gray-500">
                      {whenLabel}
                    </time>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="mt-6 px-2 text-xs text-gray-500">No activity yet.</p>
      )}
    </div>
  );
}
